import { I18n } from 'aws-amplify';


export const strings = {
    noData: I18n.get('No data to display'),
    resetZoom: I18n.get('Reset zoom'),
    loading: I18n.get('Loading...')
}